import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Audiencetruth() {
  return (
    <section className="platform_feature p-100 text_second_text">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/Target_Audience.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={561}
                height={504}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              Target <span>Audience</span>
            </h2>
            <p>
              TruthGPT caters to information seekers, fact-checkers, and users
              desiring unbiased responses in a convenient chatbot format.
            </p>
            <p>
              The target audience values transparency, reliability, and
              convenience in obtaining information.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Audiencetruth;
